<template>
  <main class="sa-content sa-mob-cont">
    <div class="sa-card-large">
      <template v-if="!ChatHistory">      
        <follow-up  v-if="followUpViewFlag"/>
        <div v-if="loader">
          <img src="../../../../src/assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
        </div>
        <div class="sa-review" v-else>
          <div class="sa-mob-header">
            <h5 class="sa-card-tit">Review Diagnosis</h5>
            <button class="sa-btn-back" @click="$router.go(-1)">
                <i class="icon-arrow-left"></i>
              </button>
          </div>
          <div class="sa-mob-cont">
          <h5 class="sa-card-tit">General details</h5>
          <div class="sa-row">
                <div class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <div class="sa-form-group">
                  <label>Select Marital Status</label>
                  <div class="sa-card">{{diagnosis.general_details.marital_status}}</div>
                  </div>
                </div>
                <div v-if="diagnosis.general_details.gender != 'Male' " class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <div class="sa-form-group">
                  <label>Select Pregnancy status</label>
                  <div class="sa-card">{{diagnosis.general_details.pregnency_status}}</div>
                  </div>
                </div>
          </div>
          <h5 class="sa-card-tit">Diagnosis details</h5>
          <div class="sa-card">
                <label class="sa-diagno-label">
                  Subjective
                </label>
              {{diagnosis.diagnosis_details.subjective}}
            </div>
            <div class="sa-card">
              <label class="sa-diagno-label">
                Objective
              </label>
              {{diagnosis.diagnosis_details.objective}}
            </div>
            <div v-if="typeof diagnosis.diagnosis_details.assessment == 'string'" class="sa-card">
              <label class="sa-diagno-label">
                Assessment
              </label>
              {{diagnosis.diagnosis_details.assessment}}
            </div>


            <div v-else-if="diagnosis.sales_channel !='bupa_refill'" class="sa-card">
                <label class="sa-diagno-label">
                Assessment
              </label>
                <div class="sa-row sa-med-tab-cnt">
                
                    <div  v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && diagnosis.diagnosis_details.assessment.secondary" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              
              <p>Primary diagonosis</p>
              <p v-if="diagnosis.diagnosis_details.assessment.primary.length == 0">Not Submitted</p>
              <p v-for="(item, index) in diagnosis.diagnosis_details.assessment.primary" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
            </div>
            <div v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && diagnosis.diagnosis_details.assessment.secondary " class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              <p>Secondary diagonosis</p>
              <p v-if="diagnosis.diagnosis_details.assessment.secondary.length == 0">Not Submitted</p>
            <p v-else v-for="(item, index) in diagnosis.diagnosis_details.assessment.secondary" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
            </div>
            <div v-if="diagnosis && diagnosis.diagnosis_details && diagnosis.diagnosis_details.assessment && diagnosis.diagnosis_details.assessment.secondary" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4  ">
              <p>Additional diagonosis</p>
              <p v-if="diagnosis.diagnosis_details.assessment.additional.length == 0">Not Submitted</p>
              <p v-else v-for="(item, index) in diagnosis.diagnosis_details.assessment.additional" :key="index" class="sa-black-text">
                {{item.icd10_code}} ({{item.desc}})</p>
              
            </div>
                </div>
            </div>
            <assessment v-else :assesment="diagnosis.diagnosis_details.bupaAssessmet"/>
            <div class="sa-card sa-mb20">
              <label class="sa-diagno-label">
                Plan
              </label>
              {{diagnosis.diagnosis_details.plan}}
            </div>
            <div v-if="diagnosis && diagnosis.followUp_slot == {}" class="sa-follow"></div>
            <div v-else  class="sa-follow">
                <h5  v-if="diagnosis && diagnosis.followUp_slot && diagnosis.followUp_slot.date" class="sa-card-tit sa-mt20">Select follow up date and slot (Optional)</h5>
                <div v-if="diagnosis && diagnosis.followUp_slot && diagnosis.followUp_slot.date" class="sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
                    <a
                        class="sa-card sa-card-noshadow sa-card-border  sa-d-block sa-follow-icon sa-gray-bg ">
                        <i class="icon-picker"></i>
                        {{diagnosis.followUp_slot.date}}, {{diagnosis.followUp_slot.strt_tym}} to {{diagnosis.followUp_slot.end_tym}}
                    </a>
                </div>
            </div>
              <h5 v-if="diagnosis && diagnosis.prescription_details && diagnosis.prescription_details.pres && diagnosis.prescription_details.pres.length > 0" class="sa-card-tit sa-mt20">Prescription</h5>
              <div v-if="diagnosis && diagnosis.prescription_details && diagnosis.prescription_details.pres && diagnosis.prescription_details.pres.length > 0" class="sa-row">
                <div  v-for="(item, i) in diagnosis.prescription_details.pres" :key="i" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">
                  <div class="sa-card ">
                  <div :ref="presDiag" @click="openToggle(i)" :class="open[i]?'active':''" class="sa-cursor sa-word-break">
                    {{item[0].value}}
                      <span  :class="{ 'icon-plus sa-added-med': !open[i], 'icon-minus sa-added-med': open[i] }"></span>
                  </div>
                  <transition>
                      <div class="sa-pre-acc-cnt" v-show="open[i]">
                        <div class="sa-row sa-med-tab-cnt">
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 sa-med-tab-cnt ">
                            <label>{{item[1].name}}</label>
                            <span>{{item[1].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[2].name}}</label>
                            <span>{{item[2].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[3].name}}</label>
                            <span>{{item[3].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[4].name}}</label>
                            <span>{{item[4].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[5].name}}</label>
                            <span>{{item[5].value}}</span>
                          </div>
                          <div class="sa-col-xs6 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[6].name}}</label>
                            <span>{{item[6].value}}</span>
                          </div>
                          <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6 ">
                            <label>{{item[7].name}}</label>
                            <span>{{item[7].value}}</span>
                          </div>
                          <div class="sa-col12 ">
                            <label>{{item[8].name}}</label>
                            <span>{{item[8].value}}</span>
                          </div>
                          <div class="sa-col12">
                            <label>{{item[9].name}}</label>
                            <span>{{item[9].value}}</span>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
              <!-- <button class="pdf-btn sa-primary-text "></button> -->
                </div>
              <div v-if="diagnosis && diagnosis.prescription_details && diagnosis.prescription_details.pres_url" class="sa-col-xs12 sa-col-sm6 sa-col-md3 sa-col-lg3">
                  <a target="_blank" :href="diagnosis.prescription_details.pres_url" class="sa-card sa-card-noshadow sa-card-border sa-text-center sa-d-block">
                    <i class="icon-pdf sa-pdf"></i> Prescription
                  </a>
                </div>
            </div>
            <h5 v-if="diagnosis && diagnosis.treatment_referal && (diagnosis.treatment_referal.doctor_referred ||
            diagnosis.treatment_referal.test_packages_referred || diagnosis.treatment_referal.nurse_referred || diagnosis.treatment_referal.treatment_referred )"  class="sa-card-tit ">Treatment Referral</h5>
            <ul class="sa-refer-list sa-treat-ref-list sa-mb20">
              <li v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.doctor_referred && diagnosis.treatment_referal.doctor && diagnosis.treatment_referal.doctor.name" class="sa-sprite sa-doc-icon">
                <strong>Doctor</strong><small>Referred Doctor - {{diagnosis.treatment_referal.doctor.title}} {{diagnosis.treatment_referal.doctor.name}}</small></li>
              <li v-else-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.doctor_referred" class="sa-sprite sa-doc-icon"><strong>Doctor</strong>
              <small>Referred Department - {{diagnosis.treatment_referal.doctor.dept_name}}</small></li>
              <li v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.test_packages_referred && diagnosis.treatment_referal.test_packages && diagnosis.treatment_referal.test_packages.tests &&
              diagnosis.treatment_referal.test_packages.package && (diagnosis.treatment_referal.test_packages.tests.name.length > 0 || diagnosis.treatment_referal.test_packages.package.name.length > 0)"
                  class="sa-sprite sa-test-pack">
                <strong>Select Test and Package</strong>
                <small v-for="(item, i) in diagnosis.treatment_referal.test_packages.tests.name" :key="i">Selected Test {{item.name}}</small>
                <small v-for="(item, i) in diagnosis.treatment_referal.test_packages.package.name" :key="i">Selected Package {{item.name}}</small>
                <!-- <a class="sa-test-det">
                <i class="icon-pdf sa-pdf"></i> Prescription</a></li> -->
              <!-- <li class="sa-sprite sa-radiology"><strong>Select Radiology</strong><small>3 Radiology Selected</small></li> -->
              <li v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.nurse 
              && diagnosis.treatment_referal.nurse.name && diagnosis.treatment_referal.nurse.name.length > 0" class="sa-sprite sa-nurse">
              <strong>Nurse</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.nurse.name" :key="i">Refered Task - {{item.name}}</small></li>

              <li v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.treatment_referred 
              && diagnosis.treatment_referal.treatment.name && diagnosis.treatment_referal.treatment.name.length > 0" class="sa-sprite sa-nurse"><strong>Physiotherapist</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.treatment.name" :key="i">{{item.name}}</small></li>
             <li  v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.covid 
              && diagnosis.treatment_referal.covid.name && diagnosis.treatment_referal.covid.name.length > 0" class="sa-sprite sa-covid">
              <strong>Covid</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.covid.name" :key="i">{{item.name}}</small>
            </li>
            <li   v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.hemodialysis 
              && diagnosis.treatment_referal.hemodialysis.name && diagnosis.treatment_referal.hemodialysis.name.length > 0"  class="sa-sprite sa-hemo">
              <strong>Hemodialysis</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.hemodialysis.name" :key="i">{{item.name}}</small>
            </li>
            <li   v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.vaccination 
              && diagnosis.treatment_referal.vaccination.name && diagnosis.treatment_referal.vaccination.name.length > 0"  class="sa-sprite sa-hemo">
              <strong>vaccination</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.vaccination.name" :key="i">{{item.name}}</small>
            </li>
            <li   v-if="diagnosis && diagnosis.treatment_referal && diagnosis.treatment_referal.vitamin_iv_drip 
              && diagnosis.treatment_referal.vitamin_iv_drip.name && diagnosis.treatment_referal.vitamin_iv_drip.name.length > 0" class="sa-sprite sa-IV">
              <strong>IV</strong>
              <small v-for="(item, i) in diagnosis.treatment_referal.vitamin_iv_drip.name" :key="i">{{item.name}}</small>
            </li>
            </ul>
            <h5 v-if="diagnosis && diagnosis.sick_url" class="sa-card-tit">Sick Leave</h5>
            <div class="sa-row">
              <div v-if="diagnosis && diagnosis.sick_url" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3">
                <a target="_blank" :href="diagnosis.sick_url" class="sa-card sa-card-noshadow sa-card-border sa-text-center sa-d-block">
                  <i class="icon-pdf sa-pdf"></i> Sick leave Report
                </a>
              </div>
            </div>
            <span v-if="diagnosis && diagnosis.apnt_details && diagnosis.apnt_details.status == '4'  && diagnosis.apnt_details.stid == 'ST1'">
            <h5 class="sa-card-tit">Chat History</h5>
            <div class="sa-row">
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg3">
                <a  @click="ChatHistory=true" class="sa-card sa-card-noshadow sa-card-border sa-text-center sa-d-block sa-cursor">
                  <i class="icon-chat sa-mr10"></i> Chat History
                </a>
              </div>
            </div>
            </span>
              <follow-up-consultatin :apt='details.previous_appnt' v-if="details && details.followUp"></follow-up-consultatin>
            <div v-if="diagnosis && diagnosis.refil_note" class="sa-card sa-card-lg-grn">
              {{diagnosis.refil_note}}
            </div>                              
            <div class="sa-text-right">
              <!-- <span class="sa-switchsmall">
                <input type="checkbox" id="noshow" />
                <label for="noshow">
                  Un completed
                  <span class="sa-input-box sa-ml10"></span>
                </label>
              </span> -->
              <span v-if="diagnosis && diagnosis.apnt_details && (diagnosis.apnt_details.status == '3'|| diagnosis.apnt_details.status == '11')" class="sa-switchsmall sa-pr20 ">
                <input v-model="apnt_complete" type="checkbox" id="notific" name="notific" />
                <label for="notific" >
                  Appointment Completed
                  <span class="sa-input-box sa-ml10"></span>
                </label>
              </span>
              <button v-if="diagnosis && diagnosis.apnt_details && (diagnosis.apnt_details.status == '3'|| diagnosis.apnt_details.status == '11')" @click="saveDiagnosisDet" class="sa-btn sa-btn-large sa-btn-primary  sa-btn-block-xs sa-mob-mt20">Continue</button>
            </div>
        </div>
        </div>
      </template>
      <chat-history v-if="ChatHistory" />
  </div>
  </main>
</template>
<script>
import { pro_url, oh_url } from "../../../../config/endpoints";
import FollowUpVue from '../../appointments/diagnosis/FollowUpDate.vue';
import ChatHistory from '../../../components/chat/ChatHistory.vue';
import FollowUpConsultatin from '../../appointments/FollowUpConsultatin.vue';
import AssessmentVue from '../Assessment.vue';


export default {
  props: ["apt"],
   mounted() {
    this.reviewDiagnosisDetails();
    this.getData()
  },
  components: {
     "follow-up": FollowUpVue,
     'chat-history':ChatHistory,
     'follow-up-consultatin':FollowUpConsultatin,
     "assessment": AssessmentVue

  },
    data(){
        return{
          loader:false,
          ChatHistory:false,
          patDetails: {},
          presDiag: 0,
          appDetails: {},
          details: null,
          open: {},
          followUpFlag:false,
          followUpViewFlag:false,
          apnt_complete: false,
          diagnosis: {
        general_details: {
          marital_status: null,
          pregnency_status: null,
          gender: null
        },
        diagnosis_details: {
          subjective	:	null,
          objective	:	null,
          plan	:	null, 
          assessment: {
            primary : null,
            secondary: null,
            additional: null
          },
          treatment_referal:{
            test_packages: {},
            nurse: {},
            doctor: {}
          }
          }
      }
        }
    },
    methods:{
      openToggle(i) {
        let _self = this
        let flag = !_self.open[i]
        _self.$set(_self.open, i, flag)
        _self.presDiag += 1
      },
      followUp(){
        if(!this.followUpFlag){
          this.followUpFlag =true
          this.followUpViewFlag =true
        }
        else{
          this.followUpFlag =false
          this.followUpViewFlag =false
        }
      },
       reviewDiagnosisDetails(){
      let _self = this;
      _self.loader = true;
      _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"))
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/diagnosis/reviewDetails`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
             response.data.general_details.pregnency_status = response.data.general_details.pregnency_status ? (response.data.general_details.pregnency_status == true ? "Yes" : "No") : "No"
           _self.diagnosis = response.data;
           if(_self.diagnosis && _self.diagnosis.prescription_details && _self.diagnosis.prescription_details.pres && _self.diagnosis.prescription_details.pres.length) {
            for (let index = 0; index < _self.diagnosis.prescription_details.pres.length; index++) {
              _self.open[index] = false
            }
           }
           
          }
          
        })
    },
     saveDiagnosisDet() {
        let _self = this;
      _self.loader = true;
      let complete = null;
      let status = _self.patDetails.status
       let preg_status = this.diagnosis.general_details ? (this.diagnosis.general_details.pregnency_status ? 'Yes' : true) : false
     if(_self.apnt_complete){
        complete = "4"
     } else {
       complete = (_self.patDetails.status).toString()
     }
      if(typeof this.diagnosis.diagnosis_details.assessment == 'object'){
        this.diagnosis.diagnosis_details.assessment.primary = _.map(_self.diagnosis.diagnosis_details.assessment.primary, e => {
          e = e.icd10_code
          return e
        })
        this.diagnosis.diagnosis_details.assessment.secondary = _.map(_self.diagnosis.diagnosis_details.assessment.secondary, e => {
          e = e.icd10_code
          return e
        })
        this.diagnosis.diagnosis_details.assessment.additional = _.map(_self.diagnosis.diagnosis_details.assessment.additional, e => {
          e = e.icd10_code
          return e
        })
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/apt/update`,
          body: {
            apnt_id: _self.$route.params.appid,
            complete: complete,
            preg_status: this.pregnency_status,
            treatment_plan: this.diagnosis.diagnosis_details.plan,
            subjective: this.diagnosis.diagnosis_details.subjective,
            summary: this.diagnosis.diagnosis_details.assessment,
            objective: this.diagnosis.diagnosis_details.objective,
            marital_status: this.diagnosis.general_details.marital_status
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch('SET_ALERTMESSAGE', {msg: 'Appointment Completed Successfully', class: 'sa-a-success'})
           this.$router.push({ path: `/appointments?stid=all&&app_stat=3` }) 
          }else{
              _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.err, class: 'sa-a-danger'})
            if(response&& response.followUp == false){
               _self.$store.dispatch('SET_ALERTMESSAGE', {msg: response.message, class: 'sa-a-danger'})
            }
            this.reviewDiagnosisDetails()
          }
          
        })
    },
    getData() {
      let _self = this;
      _self.appDetails =  JSON.parse(this.$localStorage.get("appDetails"))
      _self.loading = true;
      let wobj = {};
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/apt/${_self.$route.params.appid}`,
          query: wobj
        })
        .then(response => {
          if (response && response.status === 1000) {
            if(response.data && response.data.previous_appnt){
              response.data.previous_appnt.general_details.pregnency_status = (response.data.previous_appnt.general_details.pregnency_status == true)?'Yes' : 'No'
            }
            _self.details = response.data;
          } else {
          }
        })
        .catch(e => {
         // console.log(e);
        });
    }
    }
}
</script>
